import { Close } from "@mui/icons-material";
import { Button, Modal, Box, IconButton } from "@mui/material";

const ConfirmDeleteModal = ({
    open,
    onClose,
    onConfirm,
    title = "Confirmação para excluir",
    description = "Você tem certeza que você quer excluir esse item?\nEssa ação não pode ser desfeita.",
}) => {
    return (
        <Modal
            open={open}
            // onClose={onClose}
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                pt: "20vh",
            }}
        >
            <Box
                id="delete-modal-container"
                className="modalInterno"
                sx={{
                    maxHeight: "100%",
                    width: "100%",
                    maxWidth: 400,
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    position: "relative",
                    overflowX: "hidden",
                    overflowY: "auto",
                }}
            >
                <Box className="formHeader">
                    <Box className="formTitle">{title}</Box>

                    <IconButton
                        edge="end"
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            top: 6,
                            right: 18,
                        }}
                    >
                        <Close />
                    </IconButton>
                </Box>

                <Box className="formContent">
                    <Box sx={{ whiteSpace: "pre-line" }}>{description}</Box>

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 2,
                            marginTop: 3,
                        }}
                    >
                        <Button
                            onClick={onClose}
                            variant="contained"
                            sx={{
                                backgroundColor: "#eee",
                                color: "#253044",
                                minWidth: "100px",
                            }}
                        >
                            Cancelar
                        </Button>

                        <Button
                            onClick={() => {
                                onConfirm();
                                onClose();
                            }}
                            variant="contained"
                            color="error"
                            sx={{
                                minWidth: "100px",
                            }}
                        >
                            Excluir
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
};

export default ConfirmDeleteModal;
